import React, { useEffect, useRef } from "react";
import Project from "./project.tsx"
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

function AnimatedItem({ item, delay_seconds, reset}) {
  const ref = useRef(null);
  const controls = useAnimation();
  const [inViewRef, inView] = useInView({
    triggerOnce: false,  // Trigger animation only once
    threshold: 0.1,     // Start animation when 10% of the element is in view
  });

  // Combine ref from useInView and the element's ref
  const setRefs = (el) => {
    ref.current = el;
    inViewRef(el);
  };
  useEffect(() => {
    if (reset === 0){
      controls.start("hidden").then(() => {
        // Restart the animation if the element is still in view
        if (inView) {
          controls.start("visible");
        }
      });
    }
    if (inView) {
      controls.start("visible");
    }
  }, [inView, controls, reset]);

  return (
    <motion.div
    whileHover={{ scale:1.05 }}
    whileTap={{ scale: 0.95 }} className="pt-5
    ">
    
    
    <motion.div 
   
    ref={setRefs}
    variants={{
      hidden: { opacity: 0, y: 25 },
      visible: { opacity: 1, y: 0 },
    }}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.4,
        delay:delay_seconds,
      }}>
      <Project name={item[0]} description={item[1]} image={item[2]} url={item[3]}/>
    </motion.div>
    </motion.div>
  );
};


export default AnimatedItem;
